<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "User Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current user config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'User Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                 <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th>
                {{ title.username }}
                </th>
                <th>
                {{ title.privilege }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in userTable"
                :key="row.profileId"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.username }}</div>
                </td>
                <td>
                  <div>{{ row.privilege }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'User Edit'"
              @close="clkCancel()"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="username">{{
                    title.username
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                    <input
                      type="text"
                      class="form-control"
                      id="username"
                      maxlength="64"
                      :disabled="isEditClik"
                      v-model="userForm.username"
                      placeholder="String<1-64>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="password">{{
                    title.password
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      maxlength="96"
                      v-model="userForm.password"
                      placeholder="String<1-96>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="cpassword">{{
                    title.cpassword
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                    <input
                      type="password"
                      class="form-control"
                      id="cpassword"
                      maxlength="96"
                      v-model="userForm.cpassword"
                      placeholder="String<1-96>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="pir">{{
                    title.privilege
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      type="text"
                      class="form-control"
                      id="pir"
                      v-model="userForm.privilege"
                    >
                     <option value="0">normal(0)</option>
                      <option value="1">normal(1)</option>
                      <option value="2">administrator(2)</option>
                      <option value="3">administrator(3)</option>
                      <option value="4">administrator(4)</option>
                      <option value="5">administrator(5)</option>
                      <option value="6">administrator(6)</option>
                      <option value="7">administrator(7)</option>
                      <option value="8">administrator(8)</option>
                      <option value="9">administrator(9)</option>
                      <option value="10">administrator(10)</option>
                      <option value="11">administrator(11)</option>
                      <option value="12">administrator(12)</option>
                      <option value="13">administrator(13)</option>
                      <option value="14">administrator(14)</option>
                      <option value="15">administrator(15)</option>
                    </select>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>


<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"

export default {
  name: "profileDs",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      maxProfileNum:"",
      isSelectAll: false,
      iBox: {},
      select: [],
      userForm: {
        username: "",
        password: "",
        cpassword: "",
        privilege:"",
      },

      userTable: [],
    }
  },

  created() {
    this.loadUserInfo()
  },

  methods: {
    loadUserInfo() {
      get("userinfo")
        .then((res) => {
          this.userTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        username: "",
        password: "",
        cpassword: "",
        privilege:"",
      }

      this.userForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.profileId) - Number(b.profileId)
    },

    clkApply() {
      var newProfile = {
        username: this.userForm.username,
        password: this.userForm.password,
        cpassword: this.userForm.cpassword,
        privilege: Number(this.userForm.privilege),
        operate: 1,
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if(this.userForm.privilege == "")
        newProfile.privilege = 1

      if (this.isEditClik) {
        newProfile.operate = 3
      }

      post("userinfo", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadUserInfo()
            /*if (this.isEditClik) {
              let editindex = this.select[0]
              this.userTable[editindex]= newProfile
            }
            else
            {
              this.userTable.push(newProfile)
              this.userTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.userTable.length; i++) {
        if (this.userTable[i].selected) {
          this.userForm.username = this.userTable[i].username
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        username: "",
        operate: 2,
      }

      for (i = 0; i < this.userTable.length; i++) {
        if (this.userTable[i].selected) {

          if(i == 0 )
          {
            this.showAlertBox("warn", "Message", "Can't delete default admin user.")
            return
          }
          newProfile.username = this.userTable[i].username
          del.push(post("userinfo", newProfile))
          id.push(this.userTable[i].username)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.userTable.length; i++) {
                if (this.userTable[i].username == id[index]) {
                  this.userTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.userTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.userTable[i], "selected", true)
        } else {
          this.$set(this.userTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    input_para_check(value)
    {
      if (value == 1 || value == 0) {
        
        if (this.userForm.username != "") {
            if (this.userForm.username.match(/^(?=[\u0020-\u007e]+$)[\S]{1,64}$/) == null) {
              return "Username contains invalid character"
            }
        }
      }

      if (value == 2 || value == 0) {
        if (this.userForm.password != "") {
            if (this.userForm.password.match(/^(?=[\u0020-\u007e]+$)[\S]{1,96}$/) == null) {
              return "Password contains invalid character"
            }
        }
      }

      if (value == 3 || value == 0) {
        if (this.userForm.cpassword != "") {
            if (this.userForm.cpassword.match(/^(?=[\u0020-\u007e]+$)[\S]{1,96}$/) == null) {
              return "Confirm password contains invalid character"
            }
        }
      }
      return null

    }
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>